<template>
	<div class="install-company-fiscal">
		<div class="install-field">
			<label class="field-label">{{ $t('install.company.f.name') }}:</label>
			<div class="input-container">
				<nk-input v-model="value_local.company.name" :options="componentOptions.companyInput" :tabindex="10" startup @update:modelValue="emitValue"></nk-input>
				<icon class="field-icon-right" name="building" group="light" />
			</div>
		</div>

		<div class="install-field">
			<label class="field-label">{{ $t('install.fiscalPeriod.f.startDate') }}:</label>
			<div class="input-container">
				<nk-date class="date" v-model="value_local.fiscalPeriod.startDate" :tabindex="11" @update:modelValue="emitValue"></nk-date>
			</div>
		</div>

		<div class="install-field">
			<label class="field-label">{{ $t('install.fiscalPeriod.f.endDate') }}:</label>
			<div class="input-container">
				<nk-date class="date" v-model="value_local.fiscalPeriod.endDate" :tabindex="12" @update:modelValue="emitValue"></nk-date>
			</div>
		</div>

		<div class="install-field">
			<label class="field-label">{{ $t('install.fiscalPeriod.f.name') }}:</label>
			<div class="input-container">
				<nk-input v-model="value_local.fiscalPeriod.name" :options="componentOptions.fiscalPeriodInput" :tabindex="13" @update:modelValue="emitValue"></nk-input>
				<icon class="field-icon-right" name="file-signature" group="light" />
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: ['modelValue'],
		emits: ['update:modelValue'],
		data() {
			return {
				value_local: {
					company: {
						name: null,
					},
					fiscalPeriod: {
						name: null,
						startDate: null,
						endDate: null,
					},
				},
				componentOptions: {
					companyInput: {
						// placeholder: this.$t('install.company.f.name')
					},
					fiscalPeriodInput: {
						// placeholder: this.$t('install.fiscalPeriod.f.name')
					}
				}
			}
		},
		watch: {
			'value_local.fiscalPeriod.endDate': {
				immediate: true,
				handler(val) {
					if (val) {
						let date = new Date(val).toLocaleDateString('fa-IR')
						this.value_local.fiscalPeriod.name = this.$t('fiscal.f.fiscal-text', { date: date })
						this.emitValue()
					}
				},
			},
			modelValue: {
				deep: true,
				immediate: true,
				handler(val) {
					this.value_local = _.cloneDeep(val)
				}
			}
		},
		methods: {
			emitValue() {
				this.$emit('update:modelValue', this.value_local)
			}
		}
	}
</script>

<style></style>
